// extracted by mini-css-extract-plugin
module.exports = {"app_wrapper":"App_app_wrapper__YgP0g","app":"App_app__25_9-"};